<template>
    <v-container>
        <loader v-if="isloading"></loader>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar flat color="#1d2735" dark style="border-radius: 5px">
                        <v-icon class="white--text" style="font-size: 45px">mdi-account-supervisor-circle</v-icon>
                        <pre><v-toolbar-title><h2>Planificaciones</h2></v-toolbar-title></pre>
                    </v-toolbar>
                    <v-data-table dense :headers="headers" hide-default-footer :items="contrato.lineas" item-key="id"
                        class="elevation-1">
                        <template v-slot:item.cantidad="{ item }">
                            {{ formatNumber(item.cantidad) }}
                        </template>
                        <template v-slot:item.resta="{ item }">
                            {{ item.cantidad - item.utilizado }}
                        </template>
                        <template v-slot:item.action="{ item }">
                            <router-link :to="{
                                path: `guardar-planificacion?id=${item.id}`,
                            }" class="action-buttons">
                                <v-btn small class="mr-2" color="primary" title="Crear" labe>Crear planificación</v-btn>
                            </router-link>
                        </template>
                    </v-data-table>
                    <v-form class="mt-3"> </v-form>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <div style="">
                        <plan-show></plan-show>
                    </div>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            rol: 0,
            headers: [
                { text: "Producto", value: "producto", sortable: false },
                { text: "Origen", value: "cantidad", sortable: false },
                { text: "Hasta la fecha", value: "utilizado", sortable: false },
                { text: "Resta", value: "resta", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],

            productos: [],

            contrato: {
                id: null,
                fecha: new Date(
                    Date.now() - new Date().getTimezoneOffset() * 60000
                )
                    .toISOString()
                    .substr(0, 10),
                revisado: false,

                id: null,
                id_cliente: null,
                iva: 0,
                subtotal: 0,
                iva: 0,
                dcto: 0,
                id_tipo_dcto: 1,
                total: 0,
                lineas: [],
                lineas_deleted: [],
                id_estado: 1,
            },
        };
    },

    created() {
        this.rol = localStorage.getItem("role");

        if (this.$route.query.id) {
            //console.log("cliente");
            this.getContrato(this.$route.query.id);
        }
    },
    methods: {
        formatNumber(number) {
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
        getContrato(id) {
            axios.get(`api/getcontrato/${id}`).then(
                (res) => {
                    this.contrato = res.data;
                    this.contrato.lineas_deleted = [];

                    if (this.contrato.cliente != null) {
                        if (this.contrato.cliente.length > 0) {
                            //console.log(this.contrato.cliente);
                            this.email = this.contrato.cliente[0].email;
                        }
                    }
                    if (Number.parseFloat(this.contrato.iva.toString()) != 0) {
                        this.enable_iva = true;
                    }
                },
                (res) => { }
            );
        },
    },
    filters: {},

    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        provincias() {
            return this.$store.getters.getprovincias;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}

.spacing {
    padding-top: 0 !important;
}
</style>
